import { handleAddContract, handleEditContract } from 'serviceWorker/services/contracts';
import { contractSource } from 'serviceWorker/services/contracts/contractSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { contractChannelContract } from 'shared/domain/contract/contractChannelContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the contract requests: one contract for its details view, and changes,
 * answered once queued (the outcome follows as an event with their `uniqueId`).
 */
export function serveContractRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(contractChannelContract, contractSource),
    channelServer.handle(contractChannelContract, {
      getOneById: ({ id }) => contractSource.getOneById(id),
      create: handleAddContract,
      edit: handleEditContract,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
